'use es6';

import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
import Immutable from 'immutable';
export default class ClientExample extends Immutable.Record({
  clientUrl: '',
  imageUrl: '',
  id: ''
}) {
  constructor(values) {
    const data = Object.assign({}, values);
    super(Object.assign({}, cleanObject(data), {
      id: uniqueId('client-example-')
    }));
  } // 'id' is used as a unique key that persists as the record updates, for ListTransition


  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }

}